module.exports = __webpack_public_path__ + "img/truss_bridge_designs_button.34638cc1.jpg";